import { vsprintf } from 'sprintf-js'
import { RoleHelper } from '../common/helpers/RoleHelper'
import { Controller } from '../common/Controller';
export class AppRoleHelper extends RoleHelper {

  getPathByOrgType(orgType) {
    if(orgType === 'ADVERTISER') return 'advertisers'
    else if(orgType === 'PARTNER') return 'partners'
    else if(orgType === 'PA') return 'pas'
    else if(orgType === 'FA') return 'fas'
    else if(orgType === 'SITE') return 'sites'
    else return 'orgs' // default
  }

  getHome() {
    if (this.isProductSU() || Controller.get().userMgr().isInOrg('PRODUCT')) {
      const userRoles = this.getUserRolesOfOrg()
      if (userRoles && userRoles.length > 0) {
        if(userRoles.includes('VIEWER')) return '/admin'
        if(userRoles.includes('SUPERUSER')) return '/admin'
        if(userRoles.includes('ORGS')) return '/admin'
        if(userRoles.includes('CAMPAIGNS')) return '/admin/campaigns'
        if(userRoles.includes('VENUES')) return '/admin/screens'
        if(userRoles.includes('REPORTS')) return '/admin/reports'
      } else {
        return '/admin'
      }
    }
    if (this.isInOrgType('ADVERTISER')) {
      return vsprintf('/admin/%s/%s', [this.getPathByOrgType('ADVERTISER'), this.getOrgId()])
    }
    if (this.isInOrgType('PARTNER')) {
      return vsprintf('/admin/%s/%s', [this.getPathByOrgType('PARTNER'), this.getOrgId()])
    }
    if (this.isInOrgType('PA')) {
      return vsprintf('/admin/%s/%s', [this.getPathByOrgType('PA'), this.getOrgId()])
    }
    if (this.isInOrgType('FA')) {
      return vsprintf('/admin/%s/%s', [this.getPathByOrgType('FA'), this.getOrgId()])
    }
    if (this.isInOrgType('SITE')) {
      return vsprintf('/admin/%s/%s', [this.getPathByOrgType('SITE'), this.getOrgId()])
    }
    if (this.isOrgSU()) {
      return '/admin/orgs/' + this.getOrgId()
    }
    return '/no-permission'
  }

  isAccessAllowed(options) {
    if (this.isProductSU()) {
      return true
    }
    if (this.isOrgSU() && (options.path.startsWith('/admin/orgs/' + this.getOrgId()))) {
      return true
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/helpers/AppRoleHelper.js